module.exports = __webpack_public_path__ + "img/img-105.983c0771.png";